import OSS from 'ali-oss'
import { http } from '@/api/http'
import { uuid } from './perf'
import { resp, download, getSuffix } from './file'

interface RequestOptions {
  headers: Record<string, any>;
  withCredentials: boolean;
  file: File;
  data: any;
  filename: string;
  action: string;
  onProgress: (e: { percent: number }) => void;
  onSuccess: (res: any) => void;
  onError: (err: Error) => void;
}

let timmer: any = null

const config = {
  endpoint: '',
  accessKeyId: '',
  accessKeySecret: '',
  bucket: '',
  endPoint: '',
  stsToken: '',
  path: '',
  expiration: '',
  timeout: 60 * 60 * 1000,
  secure: true // 使用https
}

export function oosRequest (options: RequestOptions) {
  const params = Object.assign({}, config) as any
  const path = genOssFilename(options.file)
  delete params.expiration
  params.path = path
  const client = new OSS(params)
  const data = options.file
  options.onProgress({ percent: 50 })
  return client.multipartUpload(path, data, {
    timeout: 60 * 60 * 1000,
    partSize: 500 * 1024
  }).then((result: any) => {
    options.onProgress({ percent: 100 })
    let { res: { requestUrls } } = result
    requestUrls = requestUrls.length < 1 ? '' : requestUrls[0]
    if (requestUrls.indexOf('?') > -1) requestUrls = requestUrls.split('?')[0]
    result.url = getPrivateUrl(requestUrls)
    options.onSuccess(result)
    return result
  }).catch((e: any) => {
    options.onError(e)
  })
  function genOssFilename (file: File) {
    const suffix = getSuffix(file.name)
    const timestamp = new Date().getTime()
    let fileName = getFileName(file.name)
    const reg = /`|~|!|@|#|\$|%|\^|&|\+|\*/g
    fileName = fileName.replace(reg, '')
    return config.path + '/' + fileName + '_timestamp_' + timestamp + '.' + suffix
  }
  function getSuffix (name: string) {
    const idx = name.lastIndexOf('.')
    if (idx >= 0) return name.slice(idx + 1)
    return ''
  }

  function getFileName (name: string) {
    const idx = name.lastIndexOf('.')
    if (idx >= 0) return name.slice(0, idx)
    return ''
  }
}

function getToken () {
  return http().get('/backend/oss/stsToken').then(data => {
    const { endPoint, bucketName, region, path, accessKeyId, accessKeySecret, securityToken, expiration } = data
    const item = {
      endpoint: endPoint,
      accessKeyId,
      accessKeySecret,
      bucket: data.bucketName,
      stsToken: securityToken,
      path: path || '',
      expiration
    }
    Object.assign(config, item)
    return config
  })
}

export function scheduleRefreshToken () {
  getToken().then(() => {
  }).catch((e) => {
    setTimeout(scheduleRefreshToken, 1000 * 5)
  })
  clearInterval(timmer)
  timmer = setInterval(scheduleRefreshToken, getDuration(config.expiration ? new Date(config.expiration) : new Date()))
  return Promise.resolve()

  function getDuration (time: Date) {
    const delta = 1000 * 10 // 提前 10s
    const min = 10000 * 5 // 最小间隔 5s
    const se = Math.max(time.getTime() - Date.now() - delta, min)
    return se
  }
}

export function ossDownload (name: string, url: string) {
  /**
   * 若都支持跨域用 download 方法
   */

  // getToken().then(() => {
  //   if (!url.includes(config.bucket)) { // 如果不在同一个bucket， 既不能使用ajax、也不能使用signatureUrl, 图片、pdf不支持下载
  //     resp(url, name, '_blank')
  //     return
  //   }
  //   const client = new OSS(config)
  //   const response = {
  //     'content-disposition': `attachment; filename=${encodeURIComponent(name)}`
  //   }
  //   const flag = '/tmp/'
  //   const idx = url.indexOf(flag)
  //   const id = url.slice(idx + 1)
  //   const path = client.signatureUrl(id, { response })
  //   resp(path, name)
  // })
  // download(url, name) // 支持跨域时用该方法

  download(url, name).catch(() => {
    console.warn('文件 [' + url + '] 不支持跨域下载')
    resp(url, name, '_blank')
  })
}

export function getPrivateUrl(url) {
  const client = new OSS({
    endpoint: config.endpoint,
    accessKeyId: config.accessKeyId,
    accessKeySecret: config.accessKeySecret,
    stsToken: config.stsToken,
    bucket: config.bucket
  })
  return client.signatureUrl(decodeURIComponent(new URL(url).pathname))
}
